import React, { useState } from "react";
import PropTypes from "prop-types";
import { BUTTON_SIZE, PrimaryButton } from "components/Buttons";
import { FormattedMessage } from "react-intl";
import { useProfileRegenerateAiSummary } from "hooks";
import { ICON_TYPE, MessageWithIcon } from "components/Icon";
import { css } from "@emotion/react";

/**
 * RegenerateAiSummaryButton
 *
 * @param {String} profileId
 */
const RegenerateAiSummaryButton = ({ profileId }) => {
  const [aiSummaryUuid, setAiSummaryUuid] = useState();
  const { handleRegenerateProfileAiSummary, loading } = useProfileRegenerateAiSummary();

  const handleClick = () => {
    handleRegenerateProfileAiSummary(profileId, setAiSummaryUuid);
  };

  return (
    <>
      <PrimaryButton disabled={loading || aiSummaryUuid} size={BUTTON_SIZE.small} onClick={handleClick}>
        <FormattedMessage id="Profile.RegenerateAiSummaryButton.Text" />
      </PrimaryButton>

      {aiSummaryUuid && (
        <span css={styles.success_text}>
          <MessageWithIcon
            messageId="Profile.RegenerateAiSummaryButton.Success"
            iconType={ICON_TYPE.checkmark}
            isSuccess
          />
        </span>
      )}
    </>
  );
};

const styles = {
  success_text: css`
    margin-left: 0.5rem;
  `,
};

RegenerateAiSummaryButton.propTypes = {
  profileId: PropTypes.string.isRequired,
};

export default RegenerateAiSummaryButton;
